import React from 'react';

import { getServiceTypeFromAppointment } from '../../util';
import type { icModel } from 'generated-ts-common';
import { AppointmentDateAndTime } from './AppointmentDateAndTime';
import { PhysicianAvatarWithInfo } from './PhysicianAvatarWithInfo';
import { Icon } from '../basic';
import { intl } from '../../lib';

type Appointment = icModel.saf.infrastructure.model.appointments.Appointment;

export interface AppointmentDetailProps {
  appointment?: Appointment;
  classNameTitle?: string;
  className?: string;
  customAddressContent?: React.ReactNode;
}

export function AppointmentDetail({
  appointment,
  classNameTitle,
  className,
  customAddressContent,
  ...props
}: Readonly<AppointmentDetailProps>): React.JSX.Element {
  const service = appointment && getServiceTypeFromAppointment(appointment);
  const appointmentSpecificCss = !appointment
    ? ' consultation-missing font-16'
    : ' consultation-title font-18';
  return (
    <div {...props} className="physician-and-date ehs-appointment-detail">
      <div className={'consultation-text' + appointmentSpecificCss}>
        {!appointment &&
          intl('dashboardportlet.view.welcome.title.appointment.no.exist')}
        {appointment && service?.displayName}
        <Icon aria-label="" iconName="arrow-line-right-s" />
      </div>
      {appointment && (
        <>
          <AppointmentDateAndTime
            appointmentStart={appointment.start}
            classNameTitle={classNameTitle}
          />
          <PhysicianAvatarWithInfo
            appointment={appointment}
            className={className}
            customAddressContent={customAddressContent}
          />
        </>
      )}
    </div>
  );
}
